import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminMomentsSettings = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/moments/settings/show.vue')
    createVueApp(ShowPage, { props })
  }
}
